import * as React from "react";

import axiosInstance from "../Api/Axios";

import Select from "../Components/Select";

const NotFinishedContracts = (props) => {
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/nonfinished-contracts`)
      .then((response) => {
        setData(response.data.data || []);
      });
  }, []);

  return (
    <Select {...props}>
      <option value=""></option>
      {data.map((contract) => {
        return (
          <option key={contract.contract_number} value={contract.contract_number}>
            {contract.name}
          </option>
        );
      })}
    </Select>
  );
};

export default NotFinishedContracts;
